var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcProfileGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.5C7.64062 6.5 9 5.16406 9 3.5C9 1.85938 7.64062 0.5 6 0.5C4.33594 0.5 3 1.85938 3 3.5C3 5.16406 4.33594 6.5 6 6.5ZM8.08594 7.25H7.6875C7.17188 7.50781 6.60938 7.625 6 7.625C5.39062 7.625 4.80469 7.50781 4.28906 7.25H3.89062C2.15625 7.25 0.75 8.67969 0.75 10.4141V11.375C0.75 12.0078 1.24219 12.5 1.875 12.5H10.125C10.7344 12.5 11.25 12.0078 11.25 11.375V10.4141C11.25 8.67969 9.82031 7.25 8.08594 7.25Z",
    fill: "#199690"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfileGreen);
export default __webpack_public_path__ + "static/media/ic-profile-green.d759630e28d5dc434b9c761e00ca73d0.svg";
export { ForwardRef as ReactComponent };